// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6454":"Widgets","6995":"Map","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6454":"ac119948","6995":"36ca00e1","7051":"ac119948"}[chunkId] + ".chunk.css";
};